import Home from '../views/pages/home';
import MainApp from '../views/pages/main-app';
import AboutUs from '../views/pages/about-us';

const routes = {
  '/': Home,
  '/home': Home,
  '/main-app': MainApp,
  '/about-us': AboutUs,
};

export default routes;
